export const DEV_ADMIN_PASSWORD = 'AdminDev123!@#';

export const DEV_INVESTOR_PASSWORD = 'Investor123!@#';
